/* DGA nieuwe huisstijl: tekst in Pressio optisch precies in het midden van labels, chips en knoppen.
   Pressio (hoofdletters) heeft een eigen verdeling van ruimte boven en onder de letters, en de browser rondt de
   regel ook nog af op hele pixels. Daardoor stond de tekst in sommige blokjes net te hoog of te laag (bijv. het witte
   label 'Kaufen oder leasen, Sie entscheiden'). Dit script meet per blokje waar de hoofdletters echt staan
   (bovenkant hoofdletter tot basislijn) en schuift de tekst zo dat de ruimte erboven en eronder gelijk is.
   - geldt voor elk element in Pressio met een eigen vlak of rand (label, chip, knop), één regel, max. 72 px hoog
   - de hoogte van het blokje verandert niet: alleen de verdeling van de binnenruimte (of de tekst schuift iets op)
   - onderdelen die later verschijnen of opnieuw worden opgebouwd (menu's, footer, carrousels) worden ook gemeten
   - bij een andere schermbreedte wordt alles opnieuw gemeten
   Meting: de positie van de tekstregel (Range) plus de vaste verhoudingen van Pressio No.53
   (basislijn op 0,85 en hoofdletterhoogte 0,74 van de lettergrootte); werkt ook in flex- en grid-knoppen en in
   verkleinde kaarten (de schaal wordt meegerekend).
   Snelheid (29-10-2026): er wordt pas gemeten als de fonts er zijn en een blokje (bijna) in beeld komt
   (IntersectionObserver), elk blokje één keer. Alleen elementen met een eigen korte tekst komen in aanmerking.
   Geen herscan meer bij klikken, hoveren of scrollen; dat kostte reactietijd (INP).
   Wordt op alle pagina's geladen (snippets/meta-tags.liquid). */
(function(){
  var ASC=0.85,CAP=0.74;
  var MAX_SHIFT=3,MIN_SHIFT=0.35,MAX_TEXT=60;
  var SEL='a,button,span,div,p,label,figcaption,li,strong,small,h1,h2,h3,h4,h5,h6,summary,em,b';
  if(!('IntersectionObserver' in window))return;
  function hasBox(c){return (c.backgroundColor!=='rgba(0, 0, 0, 0)'&&c.backgroundColor!=='transparent')||(parseFloat(c.borderTopWidth)>0&&c.borderTopStyle!=='none');}
  function textNode(el){for(var i=0;i<el.childNodes.length;i++){var n=el.childNodes[i];if(n.nodeType===3&&n.data.trim())return n;}return null;}
  function norm(s){return (s||'').replace(/\s+/g,' ').trim();}
  function reset(el){
    if(el.dataset.pgCt){el.style.removeProperty('translate');delete el.dataset.pgCt;}
    if(el.dataset.pgCp){el.style.removeProperty('padding-top');el.style.removeProperty('padding-bottom');delete el.dataset.pgCp;}
  }
  /* Alleen lezen: bepaalt de verschuiving zonder iets aan te passen (zie apply) */
  function measure(el){
    if(el.dataset.pgC)return null;
    if(!el.getClientRects().length)return null; /* nog verborgen: de observer meldt het opnieuw als het zichtbaar wordt */
    el.dataset.pgC='1';
    var tn=textNode(el);if(!tn)return null;
    var cs=getComputedStyle(el);if(!/Pressio/i.test(cs.fontFamily))return null;
    /* Het vlak: het element zelf of een ouder (max. 2 niveaus) met een eigen achtergrond of rand en dezelfde tekst */
    var box=el,bcs=cs;
    for(var i=0;i<3&&box;i++){bcs=getComputedStyle(box);if(hasBox(bcs))break;box=box.parentElement;}
    if(!box||!hasBox(bcs))return null;
    if(norm(box.textContent)!==norm(el.textContent))return null;
    var r=document.createRange();r.selectNodeContents(tn);var rects=r.getClientRects();if(rects.length!==1)return null;
    var br=box.getBoundingClientRect();
    /* Schaal (bijv. verkleinde kaarten in een carrousel): schermmaat gedeeld door de echte maat */
    var k=box.offsetHeight?br.height/box.offsetHeight:1;if(Math.abs(k-1)<0.03)k=1;
    if(br.height/k>72||br.height/k<12)return null;
    var fs=parseFloat(cs.fontSize)*k,tr=rects[0];
    var base=tr.top+ASC*fs;
    var top=(base-CAP*fs)-(br.top+parseFloat(bcs.borderTopWidth)*k);
    var bottom=(br.bottom-parseFloat(bcs.borderBottomWidth)*k)-base;
    var shift=(bottom-top)/2/k;
    if(Math.abs(shift)<MIN_SHIFT)return null;
    shift=Math.max(-MAX_SHIFT,Math.min(MAX_SHIFT,shift));
    return {el:el,box:box,tn:tn,shift:shift,pt:parseFloat(bcs.paddingTop),pb:parseFloat(bcs.paddingBottom)};
  }
  /* Alleen schrijven */
  function apply(m){
    var el=m.el,box=m.box,shift=m.shift;
    if(el!==box){
      /* Tekst in een eigen element: alleen de tekst verschuift, het vlak blijft staan */
      el.style.setProperty('translate','0 '+shift.toFixed(2)+'px');el.dataset.pgCt='1';
    }else if(m.pt+shift<0||m.pb-shift<0){
      /* Geen ruimte om de binnenruimte te verdelen: schuif de tekst zelf via een omhulling */
      var w=document.createElement('span');w.className='pg-c-text';w.style.cssText='display:inline-block;translate:0 '+shift.toFixed(2)+'px';
      m.tn.parentNode.insertBefore(w,m.tn);w.appendChild(m.tn);w.dataset.pgC='1';
    }else{
      box.style.setProperty('padding-top',(m.pt+shift).toFixed(2)+'px','important');
      box.style.setProperty('padding-bottom',(m.pb-shift).toFixed(2)+'px','important');
      box.dataset.pgCp='1';
    }
  }
  /* Meten zodra blokjes (bijna) in beeld zijn: eerst alles meten, dan alles aanpassen (geen heen-en-weer
     tussen lezen en schrijven, dat dwingt de browser steeds de opmaak opnieuw te berekenen) */
  var io=new IntersectionObserver(function(entries){
    var todo=[];
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      var m=measure(e.target);if(m)todo.push(m);
      if(e.target.dataset.pgC)io.unobserve(e.target);
    });
    todo.forEach(apply);
  },{rootMargin:'200px 0px'});
  /* Kandidaat = element met een eigen, korte tekst. Al het andere krijgt pgC='0' en wordt overgeslagen. */
  function consider(el){
    if(el.dataset.pgC)return;
    var tn=textNode(el);
    if(!tn||norm(tn.data).length>MAX_TEXT){el.dataset.pgC='0';return;}
    io.observe(el);
  }
  function collect(root){
    if(root.nodeType!==1)return;
    if(root.matches(SEL))consider(root);
    var els=root.querySelectorAll(SEL);
    for(var i=0;i<els.length;i++)consider(els[i]);
  }
  function remeasure(){
    /* Andere schermbreedte: omhullingen weghalen en alles wat gemeten was opnieuw laten meten */
    [].forEach.call(document.querySelectorAll('span.pg-c-text'),function(w){var p=w.parentNode;while(w.firstChild)p.insertBefore(w.firstChild,w);p.removeChild(w);});
    [].forEach.call(document.querySelectorAll('[data-pg-c="1"]'),function(el){reset(el);delete el.dataset.pgC;io.observe(el);});
  }
  function start(){
    collect(document.body);
    /* Onderdelen die later worden toegevoegd of gevuld (menu's, carrousels, formulieren) */
    if('MutationObserver' in window){
      var added=[],mt=null;
      new MutationObserver(function(list){
        list.forEach(function(m){[].forEach.call(m.addedNodes,function(n){added.push(n);});});
        clearTimeout(mt);
        mt=setTimeout(function(){
          var nodes=added;added=[];
          nodes.forEach(function(n){
            if(n.nodeType===3){var p=n.parentElement;if(p&&p.dataset.pgC==='0'){delete p.dataset.pgC;consider(p);}}
            else if(n.isConnected)collect(n);
          });
        },150);
      }).observe(document.body,{childList:true,subtree:true});
    }
    var rt=null,w0=window.innerWidth;
    window.addEventListener('resize',function(){
      if(window.innerWidth===w0)return; /* alleen hoogte (mobiele adresbalk): niets doen */
      w0=window.innerWidth;clearTimeout(rt);rt=setTimeout(remeasure,200);
    });
  }
  function boot(){
    /* Pas meten als Pressio geladen is, anders klopt de meting niet */
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(start);else start();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
